/* if using JEST to test code, remember to export your function*/

// We use this in order to format all the numbers, so instead of 1495000 it becomes 1 495 000.
export const formatter = new Intl.NumberFormat("sv-SE", {
  maximumFractionDigits: 0,
});
